var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceCardFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 85,
    viewBox: "0 0 121 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121 0L14.2354 19.6157L42.7058 45.7693L0 85L106.765 65.3846L78.2938 39.2307L121 0Z",
    fill: "#FFA41B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 0L14.2354 19.6157L42.7058 45.7693L0 85L106.765 65.3846L78.2938 39.2307L121 0Z",
    fill: "#FFA41B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCardFlash);
export default __webpack_public_path__ + "static/media/service-card-flash.e7349aef05d48c8bc7a110c8093240f7.svg";
export { ForwardRef as ReactComponent };